import request from '@/http/http'
const PREFIX = 'api/deer/utility/';
//验证码检验
export function verifyCode(phone, code) {
  return request({
    url: PREFIX + 'valid-verifycode/' + phone + '/' + code,
    method: 'get'
  })
}
//获取验证码
export function getCode(phone) {
  return request({
    url: PREFIX + 'send-verifycode/' + phone,
    method: 'get'
  })
}